import { useState, useEffect } from 'react'
import { Form, Formik } from 'formik'
import { useSelector, useDispatch } from 'react-redux'

import Layout from 'components/Layout'
import Loader from 'components/Loader'
import ListFilters from 'components/VenueSettings/ListFilters'
import VenueSettingsComponent from 'components/VenueSettings'

import {
  fetchVenueSettings,
  createVenueSettings,
} from 'store/VenueSettings/actions'
import {
  getVenueSettings,
  getIsVenueSettingsLoading,
} from 'store/VenueSettings/selectors'
import { getCurrentVenueUuid } from 'store/Venues/selector'
import { renderFieldsToCreateSettings } from 'utils/venueSettings'

const VenueSettings = () => {
  const [searchQuery, setSearchQuery] = useState('')
  const dispatch = useDispatch()
  const currentVenueUuid = useSelector(getCurrentVenueUuid)
  const venueSettings = useSelector(getVenueSettings)
  const isVenueSettingLoading = useSelector(getIsVenueSettingsLoading)

  useEffect(() => {
    dispatch(fetchVenueSettings(currentVenueUuid))
  }, [currentVenueUuid, dispatch])

  const initialValues = {
    alcohol_limit_message: venueSettings?.alcohol_limit_message ?? '',
    alcohol_limit_per_customer:
      venueSettings?.alcohol_limit_per_customer ?? '',
    alcohol_warning_message:
      venueSettings?.alcohol_warning_message ?? '',
    alcohol_warning_message_enabled:
      venueSettings?.alcohol_warning_message_enabled ?? false,
    check_recent_order: venueSettings?.check_recent_order ?? false,
    confirmation_number_length:
      venueSettings?.confirmation_number_length ?? 0,
    confirmation_numbers_sequential_by_stand:
      venueSettings?.confirmation_numbers_sequential_by_stand ??
      false,
    enable_inventory_management:
      venueSettings?.enable_inventory_management ?? true,
    allow_cash_payments_on_pos:
      venueSettings?.allow_cash_payments_on_pos ?? true,
    confirm_default_tip: venueSettings?.confirm_default_tip ?? false,
    tax_by_item: venueSettings?.tax_by_item ?? false,
    tax_rate_on_items: venueSettings?.tax_rate_on_items ?? true,
  }

  const handleSubmit = (values) => {
    const venueSettingsToSend = renderFieldsToCreateSettings(
      values,
      initialValues,
      currentVenueUuid
    )

    dispatch(createVenueSettings(venueSettingsToSend))
  }

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={handleSubmit}
    >
      <Form className="venue-settings-form">
        <Layout
          isSidebar
          navbarContent={
            <ListFilters
              handleSearch={setSearchQuery}
              searchQuery={searchQuery}
            />
          }
          mainContent={
            isVenueSettingLoading ? (
              <Loader />
            ) : (
              <VenueSettingsComponent searchQuery={searchQuery} />
            )
          }
        />
      </Form>
    </Formik>
  )
}

export default VenueSettings
